import React, { ReactElement } from 'react';

import { useIsPortrait } from 'components/ProvidersContainer/ScreenOrientationProvider';
import { useHistory, useParams } from 'cross-platform/react-router';

import {
  COUNTRY_SELECTOR_TITLE,
  ENGLAND_OPTION,
  NORTHERN_IRELAND_OPTION,
  SCOTLAND_OPTION,
  WALES_OPTION,
} from '../constants';
import { NHSCloseButton } from '../NHSCloseButton';
import {
  CheckCircle,
  Container,
  NHSScrollWrapper,
  Option,
  OptionsContainer,
  OptionText,
  Title,
} from '../styled';

type CountryValue = 'england' | 'scotland' | 'wales' | 'northern_ireland';

const OPTIONS: { value: CountryValue; label: string }[] = [
  { value: 'england', label: ENGLAND_OPTION },
  { value: 'scotland', label: SCOTLAND_OPTION },
  { value: 'wales', label: WALES_OPTION },
  { value: 'northern_ireland', label: NORTHERN_IRELAND_OPTION },
];

export const CountrySelectorScreen = (): ReactElement => {
  const history = useHistory();
  const { productReference } = useParams<{ productReference: string }>();
  const isPortrait = useIsPortrait();

  const handleClose = (): void => {
    history.push(`/${productReference}/login`);
  };

  const handleSelect = (value: CountryValue): void => {
    if (value === 'england') {
      history.push(`/${productReference}/nhs-login/england`);
    } else {
      history.push(`/${productReference}/login-screen`, {
        hideNHSButton: true,
      });
    }
  };

  return (
    <Container>
      <NHSScrollWrapper
        contentContainerStyle={{
          flexGrow: 1,
          justifyContent: 'center',
          paddingVertical: isPortrait ? 0 : 32,
        }}
      >
        <Title>{COUNTRY_SELECTOR_TITLE}</Title>
        <OptionsContainer>
          {OPTIONS.map(({ value, label }) => (
            <Option
              key={value}
              selected={false}
              onPress={() => handleSelect(value)}
            >
              <CheckCircle selected={false} />
              <OptionText>{label}</OptionText>
            </Option>
          ))}
        </OptionsContainer>
      </NHSScrollWrapper>
      <NHSCloseButton onPress={handleClose} />
    </Container>
  );
};

export default CountrySelectorScreen;
